import {h} from 'preact';

const OnStart = ({core}) => {
    const record = () => {
        core.recorder.record();
    };
    /*const settings = () => {
        core.setView('Settings');
    };*/
    return (
        <div className="on-start">
            <div className="controls">
                <button onClick={record}>
                    <div className="pulsating-circle"></div>
                    <img src="https://www.textfromtospeech.com/media/media/microphone-light_qCRjtyL.svg"
                         alt="Microphone"
                    />
                </button>
            </div>
            {/*<button onClick={settings}>Settings</button>*/}
        </div>
    )
}

export default OnStart;
